import moment from 'moment';
import { capitalizeFirstLetter } from './strings';
export const getShiftsFromResources = (items, propertyName) => {
  let allShifts = [];

  for (let itemIndex = 0; itemIndex < items.length; itemIndex++) {
    const item = items[itemIndex];
    try {
      if (item[propertyName]) {
        const shifts = item[propertyName].split(', ');

        for (let index = 0; index < shifts.length; index++) {
          const shift = shifts[index];
          const title = shift.split(/:(.+)/)[0];
          const withNotTile = shift.split(/:(.+)/)[1].split(' ').join('');
          const start = withNotTile.split('->')[0].split(' ').join('');
          const end = withNotTile.split('->')[1].split(' ').join('');

          const foundShift = allShifts.filter((s) => s.title === title);
          if (foundShift.length == 0) {
            allShifts.push({
              title,
              start: moment(`1900-01-01T${start}`),
              end: moment(`1900-01-01T${end}`),
              id: allShifts.length,
            });
          }
        }
      }
    } catch {
      continue;
    }
  }

  return allShifts;
};

export const syncShifts = (shifts, fromTime, toTime) => {
  const syncShift = shifts?.find((shift) => {
    const timeFormat = 'hh:mm a';
    const shiftStart = moment(shift.start).format(timeFormat);
    const shiftEnd = moment(shift.end).format(timeFormat);
    const formattedFromTime = moment(fromTime).format(timeFormat);
    const formattedToTime = moment(toTime).format(timeFormat);
    return shiftStart === formattedFromTime && shiftEnd === formattedToTime;
  });
  return syncShift ? syncShift.id : undefined;
}

export const formatShiftTitle = (title) => {
  const fixedTitle = title.replace('TO', '-');
  const desc = fixedTitle.split('(');
  const words = desc[0].toLowerCase().split(' ');
  const capitalized = words.map(w => capitalizeFirstLetter(w));
  desc[0] = capitalized.join(' ');
  return desc.join('(');
}
